import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const OB = () => {
   const [showModal, setShowModal] = useState(false)
   const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
   const handleOpenModal = (contentType, category, index, maxIndex) => {
       setModalContent({ contentType, category, index, maxIndex })
       setShowModal(true)
   }
   const handleCloseModal = () => {
       setModalContent({ contentType: '', category: '', index: 0 })
       setShowModal(false)
   }
    return (
        <>
            <div className='max-w-[1200px] mx-auto'>
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-ob.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        When a character or item falls off the map, it is called going{' '}
                        <span className='text-pborange'>O.B</span>. Characters who this occurs to will sustain{' '}
                        <span className='text-pborange'>HP damage</span>.
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <div className='mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'outside', 1)
                                }}
                                className='ss-thumb max-w-full'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-outside-1-s.webp`}
                            />{' '}
                            <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                                The amount of damage they will take depends on the map. Also, characters who O.B. will
                                be placed on the map closest to the position where they went O.B.
                            </p>
                        </div>{' '}
                        <div className='mx-auto mt-8'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'outside', 2)
                                }}
                                className='ss-thumb max-w-full'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-outside-2-s.webp`}
                            />{' '}
                            <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                                Differences in levels do not matter when using O.B. to cause damage, so it comes in
                                handy when fighting enemies stronger than you!
                            </p>
                        </div>{' '}
                    </div>{' '}
                    <p className='mt-8'>
                        By using the Throw command, things can be thrown outside of the map. They can also be thrown on
                        ice, where they can slide off the map, or be thrown from a high place, where they can go out of
                        bounds. In this way, various actions and the characteristics of the terrain itself can
                        contribute to O.B.
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'outside', 3)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-outside-3-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            If you fall off of the map via movement or from your own actions, this is not considered an
                            O.B., and damage will not be sustained.
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        Also, if an item goes O.B., that <span className='text-pborange'>item will disappear</span>.
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'outside', 4)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-outside-4-s.webp`}
                        />{' '}
                    </div>{' '}
                    <p className='mt-8'>
                        For example, if there is an item that you want, if an enemy throws it and it lands O.B., it will
                        disappear.
                    </p>{' '}
                    <p>
                        Sometimes, it might be necessary to Confine in an item you want before engaging with the enemy.
                        If the item has a Phantom confined in it, a message that says “Plundered!” will appear, and you
                        will get that item.
                    </p>{' '}
                </div>{' '}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={4}
                />
            </div>
        </>
    )
}
